export default "__VITE_ASSET__DF4sE31a__"